export enum MedicalHistoryLocateEvents {
  ValidationLocateDocumentEvent = 'MedicalHistoryValidationLocateDocumentEvent',
  ValidationLocateBlockEvent = 'MedicalHistoryValidationLocateBlockEvent',
  PdfPageHeightEvent = 'MedicalHistoryPdfPageHeightEvent',
}
